import {JudgmentPlatform} from "../checkPlatform.ts";

interface MyObject {
    [key: string]: string;
}

// 通用的调用gtag调用方法
export const sendGtagEvent = (action: string, eventParams: MyObject) => {
    // console.log(`查看ga参数：action:${action},eventParams:${JSON.stringify(eventParams)}`)
    // 判断平台
    const isApp = JudgmentPlatform.isCGTNAPPAutoJudge();
    eventParams['platform_type'] = isApp ? 'app' : 'web';

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    window.gtag('event', action, eventParams);
}